import React from 'react';

import BaseClass from '../BaseClass';

import {httpPost, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'userInfo': {},
            'list': [],
            'studyStatusList': {
                0: '待学习',
                1: '学习中',
                2: '已学完',
            },
        };
    }

    componentDidMount() {
        this.getList();
    }

    getList() {
        let url = pcUrl('/study/course');
        httpPost(url, {}, 'GET')
            .then(data => {
                if (!data) data = [];

                this.setState({
                    'list': data,
                });
            });
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">

                    <div className="index-right">
                        <div className="index-panel">
                            <div className="captain">
                                <h3>
                                    <span className="clips index-panel-xuexi-ico"></span>
                                    研究性学习
                                </h3>
                            </div>
                            <div className="panel-body">
                                {this.state.list.length > 0 ? (
                                    <table className="index-table">
                                        <tr>
                                            <th width="46%">
                                                课题名称
                                            </th>
                                            <th width="18%" className="text-center">
                                                学习进度
                                            </th>
                                            <th width="18%" className="text-center">
                                                下载报告
                                            </th>
                                            <th width="18%" className="text-center">
                                                下载证书
                                            </th>
                                        </tr>
                                        {this.state.list.filter((row, index) => index < 4).map(row => (
                                            <tr>
                                                <td> {row.courseName} </td>
                                                <td className="text-center">
                                                    <span
                                                        className="text-green">{this.state.studyStatusList[row.studyStatus]}</span>
                                                </td>
                                                <td className="text-center">
                                                    {row.reportUrl ? (
                                                        <a href={row.reportUrl} target="_blank" className="text-blue1">
                                                            <span className="clips download-ico"></span>
                                                            下载报告
                                                        </a>
                                                    ) : ''}
                                                </td>
                                                <td className="text-center">
                                                    {row.certificateUrl ? (
                                                        <a href={row.certificateUrl} target="_blank"
                                                           className="text-blue1">
                                                            <span className="clips download-ico"></span>
                                                            下载证书
                                                        </a>
                                                    ) : ''}
                                                </td>
                                            </tr>
                                        ))}
                                    </table>
                                ) : (
                                    <div className="padding-20 text-center text-gray">暂无数据</div>
                                )}
                            </div>
                        </div>
                        <div className="height-15"></div>
                        {/*
					<div className="index-panel">
						<div className="captain">
							<h3>
								<span className="clips index-panel-jishu-ico"></span>
								通用技术
							</h3>
						</div>
						<div className="panel-body">
							<table className="index-table">
								<tr>
									<th width="46%">
										课题名称
									</th>
									<th width="18%" className="text-center">
										学习进度
									</th>
									<th width="36%" className="text-center">
										下载报告
									</th>
								</tr>
								<tr>
									<td> 课题名称 </td>
									<td className="text-center"> 
										<span className="text-green">已看完</span>
									</td>
									<td className="text-center">
										<a href="javascript:;" className="text-blue1">
											<span className="clips download-ico"></span>
											下载报告
										</a>
									</td>
								</tr>
								<tr>
									<td> 课题名称 </td>
									<td className="text-center"> 
										<span className="text-green">已看完</span>
									</td>
									<td className="text-center">
										<a href="javascript:;" className="text-blue1">
											<span className="clips download-ico"></span>
											下载报告
										</a>
									</td>
								</tr>
								<tr>
									<td> 课题名称 </td>
									<td className="text-center"> 
										<span className="text-green">已看完</span>
									</td>
									<td className="text-center">
										<a href="javascript:;" className="text-blue1">
											<span className="clips download-ico"></span>
											下载报告
										</a>
									</td>
								</tr>
								<tr>
									<td> 课题名称 </td>
									<td className="text-center"> 
										<span className="text-green">已看完</span>
									</td>
									<td className="text-center">
										<a href="javascript:;" className="text-blue1">
											<span className="clips download-ico"></span>
											下载报告
										</a>
									</td>
								</tr>
							</table>
						</div>
					</div>
					*/}
                    </div>
                    <div className="clear"></div>
                </div>
            </>
        );
    }
}

